import {UPDATE_EVENTS_START} from "../../types";

export const update_events = (payload) => ({
    type: UPDATE_EVENTS_START,
    payload,
});
